module.exports = __webpack_public_path__ + "img/b06f14e.jpg";